import {useDialog} from './useDialog';

export const usePPIAnytimeDialog = () => {
  return useDialog<{id: string | undefined}>('ks-ppi-anytime');
};
